import { useCallback } from "react";
export const useFormikOnError = ({ field, form }) => {
    const { setFieldError } = form;
    const { name } = field;
    return useCallback((error, value) => {
        setFieldError(name, error);
    }, [setFieldError, name]);
};
//# sourceMappingURL=useFormikOnError.js.map